import { HubLogoIcon } from '#shared';

import { EZLayers, ZLayer } from '../../data-context';
import { useGeoMap } from '../../GeoMap';

import type { HubReportStatus } from '#entities';
import type { Point } from '#shared';

interface HubsDotsOnMapProps {
  hubs: HubReportStatus[];
}

const ICON_SIZE = 30;

export const HubsDotsOnMap = ({ hubs }: HubsDotsOnMapProps) => {
  const { projectionRef } = useGeoMap();

  return (
    <ZLayer zIndex={EZLayers.Background0}>
      {hubs.map(({ id, location }) => {
        const pt = location?.lonLat
          ? (projectionRef.current(location.lonLat) as Point)
          : null;
        if (!pt) {
          return null;
        }

        return (
          <g key={id} transform={`translate(${pt[0]}, ${pt[1]})`}>
            <g transform={`translate(${-ICON_SIZE / 2}, ${-ICON_SIZE / 2})`}>
              <HubLogoIcon width={ICON_SIZE} height={ICON_SIZE} />
            </g>
          </g>
        );
      })}
    </ZLayer>
  );
};
